import React, { useEffect, useState } from "react";
import { loadRelationsSettings, listenRelationRows } from "../services/data";

export default function RelationFilter({ user, onAddRelation }) {
  const [relations, setRelations] = useState([]);
  const [filters, setFilters] = useState({ type: "Tous", q: "" });
  const [relFields, setRelFields] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 3;

  useEffect(() => {
    if (!user?.uid) return;
    let unsubs = [];
    (async () => {
      const settings = await loadRelationsSettings(user.uid);
      const types = settings?.types || [];
      setRelFields(settings?.fields || []);
      const acc = {};
      types.forEach((t) => {
        const unsub = listenRelationRows(user.uid, t.key, (rows) => {
          acc[t.key] = rows.map(r => ({
            ...r,
            typeKey: t.key,
            typeLabel: t.label || t.key,
          }));
          setRelations(Object.values(acc).flat());
        });
        unsubs.push(unsub);
      });
    })();
    return () => { unsubs.forEach(u => { try { u(); } catch{} }); };
  }, [user?.uid]);

  // Types disponibles
  const typeOptions = ["Tous", ...Array.from(new Set(relations.map(r => r.typeLabel)))];

  // Filtrage
  const filtered = relations.filter(r => {
    const matchType = filters.type === "Tous" || r.typeLabel === filters.type;
    const matchSearch =
      !filters.q ||
      Object.values(r || {})
        .join(" ")
        .toLowerCase()
        .includes(filters.q.toLowerCase());
    return matchType && matchSearch;
  });

  // Colonnes dynamiques basées sur rel_fields
  const dynamicColumns = relFields.map(f => ({ key: f.key, name: f.name }));
  const startIndex = (page - 1) * pageSize;
  const paginated = filtered.slice(startIndex, startIndex + pageSize);
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  return (
    <div className="relation-filter">
      {/* Section filtres */}
      <div className="filters-section">
        <div className="filters-grid">
          <div className="filter-group">
            <label className="filter-label">Type de relation</label>
            <select
              className="filter-select"
              value={filters.type}
              onChange={e => setFilters(f => ({ ...f, type: e.target.value }))}
            >
              {typeOptions.map(opt => (
                <option key={opt}>{opt}</option>
              ))}
            </select>
          </div>
          <div className="filter-group">
            <label className="filter-label">Recherche</label>
            <input
              type="text"
              className="filter-input"
              placeholder="Rechercher une relation..."
              value={filters.q}
              onChange={e => setFilters(f => ({ ...f, q: e.target.value }))}
            />
          </div>
        </div>
      </div>

      {/* Tableau limité à 3 lignes */}
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Type</th>
              {dynamicColumns.map(col => (
                <th key={col.key}>{col.name}</th>
              ))}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginated.map(r => (
              <tr key={r.id}>
                <td>{r.typeLabel}</td>
                {dynamicColumns.map(col => (
                  <td key={col.key}>{r[col.key] || "-"}</td>
                ))}
                <td className="table-actions">
                  <button
                    onClick={() => onAddRelation(r)}
                    className="icon-btn"
                    title="Ajouter"
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={dynamicColumns.length + 2} style={{ textAlign: "center", color: "#888" }}>
                  Aucune relation trouvée
                </td>
              </tr>
            )}
          </tbody>
          <div className="table-footer">
            <span>
              Page {page} sur {totalPages}
            </span>
            <div className="pagination">
              <div
                className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                onClick={() => setPage(p => Math.max(1, p - 1))}
              >
                <i className="fas fa-chevron-left"></i>
              </div>
              <div
                className={`pagination-btn ${page === totalPages ? "disabled" : ""}`}
                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              >
                <i className="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </table>
      </div>
    </div>
  );
}
